import { render, staticRenderFns } from "./financeRecord.vue?vue&type=template&id=1281a030"
import script from "./financeRecord.vue?vue&type=script&lang=js"
export * from "./financeRecord.vue?vue&type=script&lang=js"
import style0 from "./financeRecord.vue?vue&type=style&index=0&id=1281a030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports